<template>
  <Popover
    trigger="manual"
    v-model="sequencePopoverVisible"
    placement="right"
    :visible-arrow="true"
    ref="popover"
  >
    <div
      class="el-popconfirm"
      data-test="sequence_popover"
    >
      <div class="flex-wrapper">
        <i
          class="icon icon-bulb popconfirm-icon--large"
        />
        <div>
          <p class="el-popconfirm__main">
            <strong>{{ $t('form.invoiceForm.fields.number.sequenceDialog.title') }}</strong>
          </p>
          <p class="popover-content">
            <small>{{ $t('form.invoiceForm.fields.number.sequenceDialog.message') }}</small>
          </p>
          <div class="action-buttons">
            <Button
              size="medium"
              type="primary"
              @click="confirm"
              data-test="sequence_popover_confirm_button"
            >
              {{ $t('form.invoiceForm.fields.number.sequenceDialog.confirm') }}
            </Button>
            <Button
              like-anchor
              size="medium"
              @click="cancel"
              data-test="sequence_popover_cancel_button"
            >
              {{ $t('form.invoiceForm.fields.number.sequenceDialog.cancel') }}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </Popover>
</template>

<script>
import { on, off } from 'element-ui/src/utils/dom';
import { CHECK_PATTERN_QUERY } from '~/queries';

export default {
  name: 'SequencePopover',
  data() {
    return {
      number: '',
      type: '',
      date: null,
      sequencePopoverVisible: false,
    };
  },
  methods: {
    assignReference(el) {
      this.$refs.popover.$refs.reference = el;
    },
    handleDocumentClick() {
      if (this.sequencePopoverVisible === true) {
        this.sequencePopoverVisible = false;
      }
    },
    checkPatternForType(number, type, date) {
      this.number = number;
      this.type = type;
      this.date = date;

      const variables = {
        number: this.number,
        ...(this.date !== null && { date: this.date }),
      };

      this.$apollo.query({
        query: CHECK_PATTERN_QUERY,
        variables,
      }).then((result) => {
        if (result.data.checkPattern) {
          this.showConfirmDialog();
        }
      });
    },
    showConfirmDialog() {
      if (this.isMobile) {
        this.$selectDialog(
          {
            title: this.$t('form.invoiceForm.fields.number.sequenceDialog.title'),
            message: this.$t('form.invoiceForm.fields.number.sequenceDialog.message'),
            button: {
              no: this.$t('form.invoiceForm.fields.number.sequenceDialog.button.no'),
              yes: this.$t('form.invoiceForm.fields.number.sequenceDialog.button.yes'),
            },
            callback: (confirm) => {
              if (confirm) {
                this.confirm();
              }
            },
          },
        );
      } else {
        this.sequencePopoverVisible = true;
      }
    },
    confirm() {
      this.$store.dispatch('settingsForm/openSettingsDialog', {
        type: 'sequencesForm',
      });

      this.$store.dispatch('settingsForm/predictPattern', {
        number: this.number,
        type: this.type,
        date: this.date,
      });

      this.sequencePopoverVisible = false;
    },
    cancel() {
      this.sequencePopoverVisible = false;
    },
  },
  watch: {
    sequencePopoverVisible(newVal) {
      if (newVal) {
        setTimeout(() => {
          on(document, 'click', this.handleDocumentClick);
        }, 500);
      } else {
        off(document, 'click', this.handleDocumentClick);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-popconfirm__main {
  margin-top: .5rem;
  margin-bottom: .5rem;
}

.flex-wrapper {
  display: flex;
}

.popconfirm-icon--large {
  font-size: 30px;
  color: $--color-primary;
  margin-right: 10px;
}

.action-buttons button {
  font-weight: 600;
  margin-bottom: .5rem;
}

.el-popconfirm {
  max-width: 400px;
}

.popover-content {
  word-break: normal;
}
</style>
